import React from 'react';
import { Rank, getRankBgColor, getRankColor } from '@/data/mockData';

interface RankBadgeProps {
  rank: Rank;
  size?: 'xs' | 'sm' | 'md';
}

export default function RankBadge({ rank, size = 'sm' }: RankBadgeProps) {
  const bg = getRankBgColor(rank);
  const text = getRankColor(rank);
  const sizeClass = size === 'xs' ? 'text-[9px] px-1.5 py-0.5' : size === 'sm' ? 'text-[10px] px-2 py-0.5' : 'text-xs px-2.5 py-1';
  return (
    <span className={`inline-flex items-center rounded border font-semibold tracking-wide ${bg} ${text} ${sizeClass}`}>
      {rank}
    </span>
  );
}